import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import classNames from 'classnames'
import React from 'react'
import styles from './ProductPromotion.module.scss'
import useMatchMedia from '../../hooks/matchMedia'
import { CatalogListItemInterface } from '../../interfaces/CatalogInterface'
import Carousel, { CarouselModEnum } from '../Carousel'
import CatalogListItem from '../CatalogList/CatalogListItem'

interface Props {
  products: CatalogListItemInterface[]
  title: JSX.Element
}

const ProductPromotion = (props: Props) => {
  const { products } = props
  const { isDesktop, isTablet } = useMatchMedia()

  if (!products || products?.length === 0) {
    return null
  }
  const carouselContent = products?.map((item, index) => (
    <div key={`${item.id}-${item.itemType}`} className={styles['product-promotion__view']}>
      <CatalogListItem item={item} classes={{ root: styles['view__item'] }} />
    </div>
  ))
  // eslint-disable-next-line no-nested-ternary
  const maxNum = isDesktop ? 4 : isTablet ? 3 : 1
  const showNum = products?.length > maxNum ? maxNum : maxNum // products.length
  return (
    <div className={styles['product-promotion']}>
      <h2 className={styles['product-promotion__heading']}>{props.title}</h2>
      <Carousel
        slidesToShow={showNum}
        infinite={false}
        slidesToScroll={showNum}
        swiping={products?.length! > maxNum}
        mode={CarouselModEnum.UPSELL}
      >
        {carouselContent}
      </Carousel>
    </div>
  )
}

export default ProductPromotion
